"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TouristsPicker = require("./TouristsPicker.desktop");
var _TouristsPickerMobile = require("./components/TouristsPickerMobile");
var _TouristsPickerMobileDropdown = require("./components/TouristsPickerMobileDropdown");
// Components:

// Interfaces:

var TouristsPicker = function TouristsPicker(props) {
  var _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$withDropdown = props.withDropdown,
    withDropdown = _props$withDropdown === void 0 ? true : _props$withDropdown;
  var MobileComponent = withDropdown ? _TouristsPickerMobileDropdown.TouristsPickerMobileDropdown : _TouristsPickerMobile.TouristsPickerMobile;
  var Component = isMobile ? MobileComponent : _TouristsPicker.TouristsPickerDesktop;
  return /*#__PURE__*/_react["default"].createElement(Component, props);
};
var _default = exports["default"] = TouristsPicker;